import { HelmetDexteel } from "@dexteel/mesf-core";
import { GasConsumptionReport } from "./components/GasConsumptionReport";

export const GasConsumptionPage = () => {
	return (
		<>
			<HelmetDexteel title="Gas Consumption" />
			<GasConsumptionReport />
		</>
	);
};
